import 'regenerator-runtime/runtime';
import { SagaIterator } from 'redux-saga';
import { select, takeEvery } from 'redux-saga/effects';
import { AngebotsId, GlobalAction, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { sharedDispatcher } from './sharedDispatcher';
import { snapshotManager } from './streckeSnapshotSaga';

export function* watchLateAck(): SagaIterator {
  yield takeEvery(GlobalActions.OWNED_STORE_INITIALIZED, safeSaga(lateAckSaga, App.TGV));
}

export function* lateAckSaga(action: GlobalAction<AngebotsId>): SagaIterator {
  const { appId, angebotsId } = action.payload;
  if (appId !== App.TKV_V2 || !angebotsId) {
    return;
  }
  const { tiergruppe, transientState }: IAppState = yield select();
  if (
    Object.values(tiergruppe.angebotsIds).includes(angebotsId) ||
    transientState.children.creating.includes(angebotsId) ||
    transientState.children.pendingDeletion.includes(angebotsId)
  ) {
    return;
  }
  snapshotManager.rememberUnlinkedChildren([angebotsId]);
  sharedDispatcher().dispatch(new GlobalActions().produktDeleted([{ appId, angebotsId }]));
}
